import axios from "axios";

import { accessTokenLoginApiRoute } from "../apiRoutes";

export async function accessTokenLoginApi(token) {
  if (token !== undefined && token !== null) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  } else {
    const queryString = window ? window.location.search : "";
    let urlParams = new URLSearchParams(queryString);
    let accessToken = urlParams.get("accessToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
  }

  return await axios
    .get(accessTokenLoginApiRoute)
    .then(res => res)
    .catch(err => err.response);
}
